module.exports = "<div *ngFor=\"let option of options\">\n  <label>\n    <div  (click)=\"setValue(option.value)\" class=\"iradio_flat-red\" [class.checked]=\"option.value === value\" aria-checked=\"false\" aria-disabled=\"false\"\n        style=\"position: relative;\">\n        <ins class=\"iCheck-helper\" style=\"position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;\"></ins>\n    </div>\n    {{option.label}}\n  </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/radio/radio.component.html
// module id = 381
// module chunks = 2